module.exports = "<div *ngIf=\"label !== ''; then showlabel\"></div>\r\n\r\n<ng-template #showlabel>\r\n    <label class=\"{{labelstyle}}\" [ngClass]=\"{'mandate-input' : mandatory}\">{{label}}</label>\r\n</ng-template>\r\n\r\n<div id=\"{{'htmlEditor' + txtId}}\" [formControl]=\"texteditor\" [ngClass]=\"texteditorcontainerstyle\" ngDefaultControl>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/infgtexteditor.control.html
// module id = ../../../../../client/app/shared/controls/infgtexteditor.control.html
// module chunks = main